import {
  BannersActionType,
  BannersState,
  HIDE_ALLOW_LIST_OVERRIDE_WARNING,
  HIDE_BLOCKED_LIMIT_WARNING,
  HIDE_PROFILE_LIMIT_WARNING,
  HIDE_ROAMING_LIMIT_INFO,
} from "./banners.types";
import {
  CREATE_PROFILES_SUCCESS,
  CreateProfilesSuccessAction,
  GET_PROFILES_SUCCESS,
  GetProfilesSuccessAction,
  SBProfile,
} from "../profiles/profiles.types";

const initProfileWarnings = (
  profiles: SBProfile[]
): Record<string, boolean> => {
  return profiles.reduce<Record<string, boolean>>(
    (state, profile) => ({
      ...state,
      [profile.id]: true,
    }),
    {}
  );
};

export const initialState: BannersState = {
  roamingLimitInfoVisible: true,
  allowListOverrideVisible: true,
  blockedLimitInfoVisible: true,
  profileLimitInfoVisible: {},
};

export const bannersReducer = (
  state: BannersState = initialState,
  action:
    | BannersActionType
    | GetProfilesSuccessAction
    | CreateProfilesSuccessAction
): BannersState => {
  switch (action.type) {
    case HIDE_ROAMING_LIMIT_INFO:
      return {
        ...state,
        roamingLimitInfoVisible: false,
      };
    case HIDE_ALLOW_LIST_OVERRIDE_WARNING:
      return {
        ...state,
        allowListOverrideVisible: false,
      };
    case HIDE_BLOCKED_LIMIT_WARNING: {
      return {
        ...state,
        blockedLimitInfoVisible: false,
      };
    }
    case GET_PROFILES_SUCCESS: {
      return {
        ...state,
        profileLimitInfoVisible: initProfileWarnings(action.payload),
      };
    }
    case CREATE_PROFILES_SUCCESS: {
      return {
        ...state,
        profileLimitInfoVisible: {
          ...initProfileWarnings(action.payload),
          ...state.profileLimitInfoVisible,
        },
      };
    }
    case HIDE_PROFILE_LIMIT_WARNING: {
      const profileId = action.payload;

      return {
        ...state,
        profileLimitInfoVisible: {
          ...state.profileLimitInfoVisible,
          [profileId]: false,
        },
      };
    }
    default:
      return state;
  }
};
